const BasePage = (props:any) => {
    return (
        <div style={{paddingTop: 70}}>
            {props.children}
        </div>
    );
}

export default BasePage;